import React from 'react';
const tailwindConfig = require('../../tailwind.config');
const tailwindDefaultConfig = require('tailwindcss/stubs/config.full');

const SecreenSizeObject = {
  ...tailwindDefaultConfig.theme.screens,
  ...tailwindConfig.theme.extend.screens,
};

const exportSecreenSize: any = {};

for (const [key, value] of Object.entries(SecreenSizeObject)) {
  exportSecreenSize[key as string] = parseInt(value as string);
}

export const SecreenSize = exportSecreenSize;

const breakpoints = Object.entries({
  ...tailwindDefaultConfig.theme.screens,
  ...tailwindConfig.theme.extend.screens,
}).map(([key, value]) => ({
  key: key,
  value: value,
}));
breakpoints.sort(
  (a, b) => parseInt(b.value as string) - parseInt(a.value as string)
);

function useScreenSize() {
  const [screenSize, setScreenSize] = React.useState<string>('');

  React.useEffect(() => {
    breakpoints.push({
      key: 'xxs',
      value: `0px`,
    });

    const mediaQueries = breakpoints.map(({ key, value }, index) => {
      const mediaQuery = window.matchMedia(`(min-width: ${value})`);

      mediaQuery.addEventListener('change', (e) => {
        if (e.matches) {
          setScreenSize(key);
        } else {
          setScreenSize(breakpoints[index + 1].key);
        }
      });

      return mediaQuery;
    });

    const setInitialScreenSize = () => {
      const width = window.innerWidth;
      for (const breakpoint of breakpoints) {
        if (width >= parseInt(breakpoint.value as string)) {
          setScreenSize(breakpoint.key);
          break;
        }
      }
    };

    setInitialScreenSize();

    return () => {
      mediaQueries.forEach((mediaQuery) => {
        mediaQuery.removeEventListener('change', () => {});
      });
    };
  }, []);

  if (screenSize === '') {
    return {
      'min-xs': true,
      'min-sm': true,
      'min-md': true,
      'min-lg': true,
      'min-xl': true,
      'min-2xl': true,
      'max-xs': true,
      'max-sm': true,
      'max-md': true,
      'max-lg': true,
      'max-xl': true,
      'max-2xl': true,
    };
  }

  return {
    'min-xs':
      screenSize === 'xs' ||
      screenSize === 'sm' ||
      screenSize === 'md' ||
      screenSize === 'lg' ||
      screenSize === 'xl' ||
      screenSize === '2xl',
    'min-sm':
      screenSize === 'sm' ||
      screenSize === 'md' ||
      screenSize === 'lg' ||
      screenSize === 'xl' ||
      screenSize === '2xl',
    'min-md':
      screenSize === 'md' ||
      screenSize === 'lg' ||
      screenSize === 'xl' ||
      screenSize === '2xl',
    'min-lg':
      screenSize === 'lg' || screenSize === 'xl' || screenSize === '2xl',
    'min-xl': screenSize === 'xl' || screenSize === '2xl',
    'min-2xl': screenSize === '2xl',
    'max-xs': screenSize === 'xxs',
    'max-sm': screenSize === 'xs' || screenSize === 'xxs',
    'max-md':
      screenSize === 'sm' || screenSize === 'xs' || screenSize === 'xxs',
    'max-lg':
      screenSize === 'md' ||
      screenSize === 'sm' ||
      screenSize === 'xs' ||
      screenSize === 'xxs',
    'max-xl':
      screenSize === 'lg' ||
      screenSize === 'md' ||
      screenSize === 'sm' ||
      screenSize === 'xs' ||
      screenSize === 'xxs',
    'max-2xl':
      screenSize === 'xl' ||
      screenSize === 'lg' ||
      screenSize === 'md' ||
      screenSize === 'sm' ||
      screenSize === 'xs' ||
      screenSize === 'xxs',
  };
}

export default useScreenSize;
